import { IMoneySourceProps } from '../../types';
import { EMoneySource } from '../../../../types/reducers/user';
import classnames from 'classnames';
import * as styles from './MoneySourceTabs.css';
import { UIText2 } from '@cian/ui-kit';
import { getTextColor } from './utils';
import * as React from 'react';

export const MoneySourceTab = ({
  label,
  value,
  disabled,
  active,
  onChange,
}: IMoneySourceProps & {
  onChange: (value: EMoneySource) => void;
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(value);
    }
  };

  return (
    <div
      className={classnames(styles['tab'], disabled && styles['disabled'], active && styles['active'])}
      data-name="MoneySourceTab"
      data-checked={active}
      onClick={handleClick}
      key={value}
    >
      <UIText2 color={getTextColor(disabled, active)} fontWeight="700">
        {label}
      </UIText2>
    </div>
  );
};
